import script from "./reasonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./reasonPage.vue?vue&type=script&setup=true&lang=js"

import "./reasonPage.vue?vue&type=style&index=0&id=e24c3c30&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e24c3c30"]])

export default __exports__